import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import MainTitle from "../../../components/ui/MainTitle";
import SubmitButton from "../../../components/form/SubmitButton";
import { useUpdateResource } from "../../../hooks/useUpdateResource";
import { useTranslation } from "react-i18next";
import LoadingButton from "../../../components/form/LoadingButton";
import { CarBrandFormData } from "../../../components/admin/carBrand/CarBrandForm";
import StoreTypeForm from "../../../components/admin/storeTypes/StoreTypeForm";

export default function AdminAddStoreTypePage() {
  const navigate = useNavigate();

  const { register, handleSubmit, formState: { errors } } = useForm<CarBrandFormData>({
    defaultValues: {
      languages: [
        { languageCode: "en", title: "" },
        { languageCode: "ar", title: "" },
      ],
    },
  });

  const [cover,setCover] = useState<File|null>(null);

   const { t } = useTranslation();
  const { loading, updateResource } = useUpdateResource();

  const onSubmit = (data: CarBrandFormData) => {
    if(!cover){
        alert(t('upload_image_required'));
        return;
    }
    const formData = new FormData();
    const languages = data.languages.map((da)=>({name:da.title,languageCode:da.languageCode}));
    formData.append("languages",JSON.stringify(languages))
    if(cover){
        formData.append("image",cover);
    }
    updateResource(`type/create`, formData,
        "admin",{
            method: "POST",
            successMessage: t("createdSuccess"),
            invalidateQueries:["store-types-by-admin"],
            navigateAfter: () => navigate("/admin/store-types"),
          });
  };

  return (
    <div className="p-6 container">
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4 w-full">
        <MainTitle title="add_new_store_type" />
        <StoreTypeForm register={register} errors={errors}cover={cover} setCover={setCover} />
        {
        loading?
        <LoadingButton height={64}/> 
        :
        <SubmitButton height={64} label="create" />
        }
      </form>
    </div>
  );
}
